"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPriceComparisonChartClick = exports.PriceComparisonChartEventSource = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var PriceComparisonChartEventSource;
(function (PriceComparisonChartEventSource) {
    PriceComparisonChartEventSource["LEFT_ARROW"] = "previous-dates";
    PriceComparisonChartEventSource["RIGHT_ARROW"] = "upcoming-dates";
    PriceComparisonChartEventSource["BEST_OFFER"] = "best-offer";
    PriceComparisonChartEventSource["DEFAULT_OFFER"] = "default-offer";
})(PriceComparisonChartEventSource || (exports.PriceComparisonChartEventSource = PriceComparisonChartEventSource = {}));
const trackPriceComparisonChartClick = (source) => (0, libs_tracking_events_1.track)({
    event: `🚀 click.priceoverview`,
    eventMetadata: {
        source,
    },
    _clear: true,
});
exports.trackPriceComparisonChartClick = trackPriceComparisonChartClick;
//# sourceMappingURL=trackORLPriceOverview.js.map